import "./Projects.scss";
import Project from "../Project/Project";
import { useTranslation } from "react-i18next";

const Projects = () => {
  const {t} = useTranslation();
  const projects = t("projects", {returnObjects: true})
  return (
    <section id="projects" className="gallery">
      <div className="gallery__wrapper">
        <h2 className="gallery__title">
          {t("projectsTitle.title1")}
          <span className="gallery__title--special">
            {t("projectsTitle.title2")}
          </span>
        </h2>
        <div className="gallery__arrange">
          {projects && projects.length > 0 ? (
            projects.map((project) => (
              <article className="gallery__details" key={project.id}>
                <Project
                  key={project.id}
                  backgroundImage={project.backgroundImage}
                  targetUrl={project.targetUrl}
                  title={project.title}
                  content={project.content}
                  skills={project.skills}
                />
              </article>
            ))
          ) : (
            <p>No Projects</p>
          )}
        </div>
      </div>
    </section>
  );
};
export default Projects;
